export async function waitForPresentationPaint({ window }: {
  window: Pick<Window, 'requestAnimationFrame'>,
}): Promise<void> {
  /**
   * WHY: A single requestAnimationFrame callback runs before that frame paints.
   * Waiting for the following frame guarantees the browser had one paint
   * opportunity before startup resumes CPU-heavy module evaluation.
   */
  await new Promise<void>((resolve, reject) => {
    window.requestAnimationFrame(() => {
      try {
        window.requestAnimationFrame(() => resolve());
      } catch (error) {
        reject(error);
      }
    });
  });
}

// Export internal state and logic used only for testing here. Do not reference these in production logic.
// ESLint-required for TypeScript modules.
export const TEST_ONLY = {
};
